<template>
  <div class="bg-white">
    <div class="relative z-index1 h-full w-full">
      <div class="">
        <Cover />
        <MasterCards />
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Cover from "./components/Cover.vue";
import MasterCards from "./components/MasterCards.vue";
import Footer from "../../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
export default {
  components: {
    Cover,
    MasterCards,
    Footer,
    DownloadApp,
  },
};
</script>

<style></style>
